import { useEffect, useState } from 'react';
import { useDeleteRoleMutation, useGetListQuery } from '../../Redux/Service/RoleApi';
import DataTable from 'react-data-table-component';
import { Dropmenu, Search } from '../../Components';
import { Button, Grid } from '@mui/material';
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import { Link, useNavigate } from 'react-router-dom';
import StyledDashboardLayout from '../style';
import { toast } from 'react-toastify';
import { useModuleHasPermissions } from '../../hooks/useModulePermissions';

export default function RolePermissions() {
   const [page, setPage] = useState(1);
   const [rowsPerPage, setRowsPerPage] = useState(10);
   const [searchInput, setSearchInput] = useState('');
   const [debouncedSearch, setDebouncedSearch] = useState('');
   const navigate = useNavigate();

   const [deleteRole] = useDeleteRoleMutation();
   const hasPermissions = useModuleHasPermissions('role_permission');
   const { data, isLoading, error, isError, refetch } = useGetListQuery(
      {
         page,
         limit: rowsPerPage,
         search: debouncedSearch,
      },
      { refetchOnFocus: true, refetchOnMountOrArgChange: true },
   );

   const handleDelete = async (id) => {
      try {
         await deleteRole(id).unwrap();
         toast.success('Role deleted successfully');
      } catch (err) {
         toast.error(err?.data?.message || 'Failed to delete role');
      }
   };

   const handleEdit = async (id) => {
      console.log('edit', id);
      navigate(`/role-edit/${id}`);
   };

   const handleView = async (id) => {
      navigate(`/role-view/${id}`);
   };

   const handleSearch = () => {
      console.log('search');
   };

   useEffect(() => {
      const timer = setTimeout(() => {
         setDebouncedSearch(searchInput);
         setPage(1);
      }, 500);

      return () => clearTimeout(timer);
   }, [searchInput]);

   const columns = [
      {
         name: 'SL No',
         cell: (row, index) => (page - 1) * rowsPerPage + index + 1,
         button: false,
      },
      {
         name: 'Role',
         selector: (row) => row.name,
         sortable: true,
         wrap: true,
         cell: (row) => (
            <div style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>{row.name}</div>
         ),
      },
      {
         name: 'Created On',
         selector: (row) => row.createdAt,
         sortable: true,
         cell: (row) => (
            <div>
               {new Date(row.createdAt).toLocaleDateString('en-GB', {
                  day: '2-digit',
                  month: 'short',
                  year: 'numeric',
               })}
            </div>
         ),
      },
      {
         name: 'Action',
         cell: (row) => {
            if (!row.isSuperAdmin)
               return (
                  <div>
                     <Dropmenu
                        handleEdit={() => handleEdit(row.id)}
                        handleView={() => handleView(row.id)}
                        handleDelete={() => handleDelete(row.id)}
                        isRolePermissionModule={true}
                        canEdit={hasPermissions?.canUpdate}
                        canDelete={hasPermissions?.canDelete}
                     />
                  </div>
               );
         },
         button: false,
      },
   ];

   return (
      <StyledDashboardLayout>
         <div className="content-wrapper">
            <div className="content-header">
               <div className="container-fluid">
                  <div className="d-flex justify-content-between mb-2">
                     <div className="pageTitle">
                        <h1 className="m-0">Users</h1>
                     </div>
                     {hasPermissions?.canAdd && (
                        <div className="btnWrap">
                           <Link to="/role-add" className="btn addBtn">
                              <PersonAddAlt1Icon /> Add Role
                           </Link>
                        </div>
                     )}
                  </div>
               </div>
            </div>
            <div className="card m-3 customCard">
               {isLoading ? (
                  <div>Loading...</div>
               ) : isError ? (
                  <div>Error: {error?.message}</div>
               ) : (
                  <div>
                     <Grid container spacing={2}>
                        <Grid item md={6} xs={12}></Grid>
                        <Grid item md={6} xs={12} display="flex" justifyContent="flex-end">
                           <Search
                              onSearch={(query) => setSearchInput(query)}
                              customPlaceHolder="Search by Role"
                           />
                        </Grid>
                     </Grid>

                     <DataTable
                        columns={columns}
                        data={data?.response.data?.map(({ id, name, isSuperAdmin, createdAt }) => ({
                           id,
                           name,
                           isSuperAdmin,
                           createdAt,
                        }))}
                        pagination
                        paginationServer
                        paginationTotalRows={data?.response?.total || 0}
                        paginationPerPage={rowsPerPage}
                        paginationRowsPerPageOptions={[5, 10, 20, 50, 100]}
                        paginationDefaultPage={page}
                        onChangePage={(newPage) => setPage(newPage)}
                        onChangeRowsPerPage={(newPerPage) => {
                           setRowsPerPage(newPerPage);
                           setPage(1);
                        }}
                        className="dataTable"
                     />
                  </div>
               )}
            </div>
         </div>
      </StyledDashboardLayout>
   );
}
